import React, {Component} from 'react';
import Form from "../../components/form/Form";

export default class ReferralModal extends Component {

    constructor(props) {
        super(props);

        this.formRef = React.createRef();
        this.state = {
            ...this.state,
            isDisabled: props.isDisabled,
            referral: {},
            didSend: false,
        };
    }

    formFields()
    {
        return [
            {
                fields: {
                    subtitle: (
                        <div className="referral-form-info">
                            <h4>
                                {TB.trans('talent.under_review.modal_form_title')}
                            </h4>
                            <p>
                                {TB.trans('talent.under_review.modal_form_subtitle')}
                            </p>
                        </div>
                    ),
                }
            },
            {
                style: {flexDirection: 'row'},
                fields: {
                    first_name: {
                        label: TB.trans('talent.under_review.modal_form_first_name_label'),
                        required: true,
                        columns: 6
                    },
                    last_name: {
                        label: TB.trans('talent.under_review.modal_form_last_name_label'),
                        required: true,
                        columns: 6
                    },
                }
            },
            {
                fields: {
                    email: {
                        label: TB.trans('talent.under_review.modal_form_email_label'),
                        type: 'email',
                        required: true,
                    },
                }
            }

        ];
    }

    async resetForm() {
        await this.formRef.current?.forceReset();
        return this.setState({didSend: false, referral: {}});
    }
    /**
     * Maps form input data to form submit model
     * Appends token to form data from url route parameter
     *
     * @param {Object} model
     * @returns {Object}
     */
    mapping(model)
    {
        model.user_type = laravel.user_types.talent;

        return model;
    }

    onChange(model)
    {
        this.setState({referral: model})
    }

    async onSuccess(model)
    {
        await this.props.onToggleDisabled(false);
        return this.setState({didSend: true});
    }

    async onBeforeError(error)
    {
        await this.props.onToggleDisabled(false);
        return TB.showServerErrorToast();
    }

    render() {

        if (this.state.didSend) {
            return (
                <p>{TB.trans('talent.under_review.modal_did_send_msg')}</p>
            )
        }
        return (
            <Form
                ref={this.formRef}
                showRequired
                submitButton={"Send"}
                post="/api/platform-referrals/create"
                model={this.state.referral}
                mapping={this.mapping.bind(this)}
                onChange={this.onChange.bind(this)}
                onSuccess={this.onSuccess.bind(this)}
                onSubmit={(e) => this.props.onToggleDisabled(true)}
                onBeforeError={this.onBeforeError.bind(this)}
                fields={this.formFields()}
                isDisabled={this.state.isDisabled || this.props.isDisabled}/>
        );
    }
};
